import { create } from "zustand";
import { UserWithRole } from "../../models/User";

interface UserRolesStore {
    // State
    users: UserWithRole[];
    selectedUser: UserWithRole | null;
    isLoading: boolean;
    error: string | null;

    // Synchronous Actions
    updateUsers: (users: UserWithRole[]) => void;
    addUser: (user: UserWithRole) => void;
    updateUser: (userId: string, updates: Partial<UserWithRole>) => void;
    removeUser: (userId: string) => void;
    selectUser: (user: UserWithRole | null) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
    clearError: () => void;
}

export const userRolesStore = create<UserRolesStore>((set, get) => ({
    // Initial State
    users: [],
    selectedUser: null,
    isLoading: false,
    error: null,

    // Synchronous Action
    updateUsers: (users) => set({ users }) ,
    
    addUser: (user) => {
        const { users } = get();
        set({ users: [...users, user] });
    },
    
    updateUser: (userId, updates) => {
        const { users } = get();
        const updatedUsers = users.map(user => 
            user.id === userId ? { ...user, ...updates } : user
        );
        set({ users: updatedUsers });
    },
    
    removeUser: (userId) => {
        const { users } = get();
        const filteredUsers = users.filter(user => user.id !== userId);
        set({ users: filteredUsers });
    },
    
    selectUser: (user) => set({ selectedUser: user }),
    
    setLoading: (loading) => set({ isLoading: loading }),
    
    setError: (error) => set({ error }),
    
    clearError: () => set({ error: null })
}));
